import React from "react";
import { BOOKING_URL, CONTACT, FACEBOOK_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";
import { PageHero, Eyebrow } from "@/components/site/Section";
import { Phone, Printer, Mail, MapPin, Facebook } from "lucide-react";

const info = [
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: CONTACT.phoneHref },
  { icon: Printer, label: "Fax", value: CONTACT.fax },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: MapPin, label: "Location", value: "1169 Appomattox Dr, Florence, KY 41042", href: CONTACT.mapHref },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contact Us"
        title="Let's Begin Your Consultation"
        subtitle="Contact Seraphina Collective to ask a question, schedule a visit, or arrange services at your home or event."
      />

      <section className="py-20 bg-[var(--cream)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-14">
          <div>
            <Eyebrow className="mb-3">Get in Touch</Eyebrow>
            <h2 className="font-display text-4xl text-[var(--charcoal)]">Contact Information</h2>
            <div className="mt-8 space-y-5">
              {info.map((it) => (
                <div key={it.label} className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-full bg-[var(--cream-2)] flex items-center justify-center text-[var(--gold)] shrink-0">
                    <it.icon size={19} />
                  </span>
                  <div>
                    <p className="eyebrow">{it.label}</p>
                    {it.href ? (
                      <a href={it.href} target={it.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="text-[var(--charcoal)] hover:text-[var(--gold)] transition-colors">{it.value}</a>
                    ) : (
                      <p className="text-[var(--charcoal)]">{it.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <BookLink label="Contact Book" href={BOOKING_URL} data-testid="contact-book-btn" className="btn-gold rounded-full px-8 py-3.5 inline-block mt-8">
              Book Appointment
            </BookLink>
          </div>

          <div className="soft-card rounded-2xl p-8">
            <Eyebrow className="mb-3">Mobile Services</Eyebrow>
            <h3 className="font-display text-3xl text-[var(--charcoal)]">We Come to You</h3>
            <p className="text-[var(--charcoal-soft)] leading-relaxed mt-4">
              We travel to your home and events too! Contact us to discuss availability and the best service
              options for your needs.
            </p>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-6 nav-link">
              <Facebook size={17} /> Visit Seraphina Collective on Facebook
            </a>
            <div className="mt-8 rounded-xl overflow-hidden border border-[var(--line)]">
              <iframe
                title="Seraphina location"
                src="https://maps.google.com/maps?q=1169%20Appomattox%20Dr%20Florence%20KY%2041042&t=&z=13&ie=UTF8&iwloc=&output=embed"
                className="w-full h-64"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
